import BaseAttachableListManager from './BaseAttachableListManager';

export default class ComponentManager extends BaseAttachableListManager {
    constructor(options = {}) {
        super({
            containerSelector: '.component-manager-container',
            detachItemSelector: '.detach-component',
            detachDataKey: 'component-id',
            notificationContainerId: 'component-manager-notifications',
            ...options,
        });

        this.availableComponents = options.availableComponents || {};
        this.pageId = options.pageId;
        this.componentTypeLabels = options.componentTypeLabels || {};
        this.reorderRoute = options.reorderRoute;
        this.showModal = false;
    }

    bindBaseEvents() {
        $(document).on('click', '.attach-component', () => {
            this.resetAttachForm();
            this.showModal = true;
            $('#attachComponentModal').modal('show');
        });

        $(document).on('change', '#componentTypeSelect', (e) => {
            this.handleComponentTypeChange($(e.target).val());
        });

        $(document).on('click', '#attach-button', () => {
            this.handleAttachSubmit();
        });

        $(document).on('click', '.detach-component', (e) => {
            const componentId = $(e.target).closest('.detach-component').data('component-id');
            const componentName = $(e.target).closest('tr').find('td[field-key="name"]').text();

            this.confirmAction(`Are you sure you want to detach "${componentName}" from this page?`).then((confirmed) => {
                if (confirmed) {
                    this.handleDetachClick(componentId);
                }
            });
        });

        $(document).on('click', '.move-up', (e) => {
            const componentId = $(e.target).closest('.move-up').data('component-id');
            this.moveComponent(componentId, 'up');
        });

        $(document).on('click', '.move-down', (e) => {
            const componentId = $(e.target).closest('.move-down').data('component-id');
            this.moveComponent(componentId, 'down');
        });

        $(document).on('hidden.bs.modal', '#attachComponentModal', () => {
            this.showModal = false;
            this.resetAttachForm();
        });
    }

    resetAttachForm() {
        $('#componentTypeSelect').val('').trigger('change');
        $('#componentSelect').empty().prop('disabled', true);
        $('#componentOrder').val('');
    }

    handleComponentTypeChange(selectedType) {
        const componentSelect = $('#componentSelect');
        componentSelect.empty().prop('disabled', true);

        if (selectedType && this.availableComponents[selectedType]) {
            componentSelect.append('<option value="">Choose a component...</option>');
            $.each(this.availableComponents[selectedType], (id, name) => {
                componentSelect.append(`<option value="${id}">${name}</option>`);
            });
            componentSelect.prop('disabled', false);
            this.setNextOrder();
        } else {
            componentSelect.append('<option value="">First select a component type...</option>');
        }
    }

    setNextOrder() {
        const lastRow = this.$container.find('tbody tr').last();
        let nextOrder = 1;

        if (lastRow.length > 0) {
            const lastOrderText = lastRow.find('td[field-key="ordered"]').text().trim();
            const lastOrderValue = parseInt(lastOrderText, 10);
            if (!isNaN(lastOrderValue)) {
                nextOrder = lastOrderValue + 1;
            }
        }

        $('#componentOrder').val(nextOrder);
    }

    validateAttachForm() {
        const errors = [];
        const type = $('#componentTypeSelect').val();
        const componentId = $('#componentSelect').val();
        const ordered = $('#componentOrder').val();

        if (!type) {
            errors.push('Please select a component type');
        }
        if (!componentId) {
            errors.push('Please select a component');
        }
        if (!ordered || isNaN(ordered) || parseInt(ordered, 10) < 1) {
            errors.push('Please enter a valid order number (minimum 1)');
        }

        return errors;
    }

    handleAttachSubmit() {
        const errors = this.validateAttachForm();

        if (errors.length > 0) {
            this.showNotification(errors.join('<br>'), 'error');
            return;
        }

        this.attachComponent({
            type: $('#componentTypeSelect').val(),
            component_id: $('#componentSelect').val(),
            ordered: parseInt($('#componentOrder').val(), 10),
        });
    }

    handleDetachClick(componentId) {
        if (!componentId) {
            this.showNotification('Invalid component ID', 'error');
            return;
        }
        this.detachComponent(componentId);
    }

    handleAttachSuccess() {
        this.showNotification('Component attached successfully!', 'success');
        this.showModal = false;
        $('#attachComponentModal').modal('hide');
        setTimeout(() => location.reload(), 1000);
    }

    handleAttachFailure(xhr) {
        this.showNotification(`Failed to attach component: ${this.extractErrorMessage(xhr)}`, 'error');
        this.showModal = false;
        $('#attachComponentModal').modal('hide');
    }

    handleDetachSuccess() {
        this.showNotification('Component detached successfully!', 'success');
    }

    handleDetachFailure(xhr) {
        this.showNotification(`Failed to detach component: ${this.extractErrorMessage(xhr)}`, 'error');
    }

    handleReorderSuccess(response, componentId, direction) {
        const hasSwap = response.data && response.data.swap;

        if (hasSwap) {
            this.showNotification('Component order updated!', 'success');
            this.updateComponentOrder(componentId, direction);
        } else {
            this.showNotification('Component is already at the ' + (direction === 'up' ? 'top' : 'bottom'), 'info');
        }
    }

    handleReorderFailure(xhr) {
        this.showNotification(`Failed to reorder component: ${this.extractErrorMessage(xhr)}`, 'error');
    }

    attachComponent(formData) {
        if (!formData.type || !formData.component_id || !formData.ordered) {
            this.showNotification('Invalid form data', 'error');
            return;
        }

        const attachButton = $('#attach-button');
        this.showLoading(attachButton, true);

        this.makeRequest(
            this.attachRoute,
            'PATCH',
            formData,
            () => {
                this.showLoading(attachButton, false);
                this.handleAttachSuccess();
            },
            (xhr) => {
                this.showLoading(attachButton, false);
                this.handleAttachFailure(xhr);
            }
        );
    }

    detachComponent(componentId) {
        const detachButton = $(`.detach-component[data-component-id="${componentId}"]`);
        this.showLoading(detachButton, true);

        this.makeRequest(
            this.detachRoute,
            'DELETE',
            { component_id: componentId },
            () => {
                this.showLoading(detachButton, false);
                this.handleDetachSuccess();
                this.removeItemFromTable(componentId);
            },
            (xhr) => {
                this.showLoading(detachButton, false);
                this.handleDetachFailure(xhr);
            }
        );
    }

    moveComponent(componentId, swapDirection) {
        if (!componentId || !swapDirection) {
            this.showNotification('Invalid component ID or direction', 'error');
            return;
        }

        const moveButton = $(`.move-${swapDirection === 'up' ? 'up' : 'down'}[data-component-id="${componentId}"]`);
        this.showLoading(moveButton, true);

        this.makeRequest(
            this.reorderRoute,
            'PATCH',
            {
                componentId_: componentId,
                swapDirection,
            },
            (response) => {
                this.showLoading(moveButton, false);
                this.handleReorderSuccess(response, componentId, swapDirection);
            },
            (xhr) => {
                this.showLoading(moveButton, false);
                this.handleReorderFailure(xhr);
            }
        );
    }

    updateComponentOrder(componentId, direction) {
        const currentRow = $(`.detach-component[data-component-id="${componentId}"]`).closest('tr');

        if (!currentRow.length) {
            return;
        }

        currentRow.addClass('table-warning');

        if (direction === 'up' && currentRow.index() > 0) {
            const prevRow = currentRow.prev('tr');
            currentRow.fadeOut(200, function () {
                currentRow.insertBefore(prevRow).fadeIn(200, function () {
                    setTimeout(() => currentRow.removeClass('table-warning'), 1000);
                });
            });
        } else if (direction === 'down') {
            const nextRow = currentRow.next('tr');
            if (nextRow.length) {
                currentRow.fadeOut(200, function () {
                    currentRow.insertAfter(nextRow).fadeIn(200, function () {
                        setTimeout(() => currentRow.removeClass('table-warning'), 1000);
                    });
                });
            }
        } else {
            currentRow.removeClass('table-warning');
        }
    }

    reorderAllItems(orderedIds) {
        if (!this.reorderAllRoute) {
            this.showNotification('Drag-and-drop reordering is not configured', 'error');
            return;
        }

        if (!orderedIds || orderedIds.length === 0) {
            return;
        }

        this.makeRequest(
            this.reorderAllRoute,
            'PATCH',
            { ordered_ids: orderedIds },
            () => this.showNotification('Components reordered successfully!', 'success'),
            (xhr) => {
                this.showNotification(`Failed to reorder components: ${this.extractErrorMessage(xhr)}`, 'error');
                setTimeout(() => location.reload(), 1500);
            }
        );
    }
}

$(document).ready(function () {
    const $container = $('.component-manager-container');
    if ($container.length === 0) {
        return;
    }

    const options = BaseAttachableListManager.optionsFromContainer($container, {
        containerSelector: '.component-manager-container',
        detachItemSelector: '.detach-component',
        detachDataKey: 'component-id',
        notificationContainerId: 'component-manager-notifications',
        extraOptions: {
            availableComponents: $container.data('available-components') || {},
            pageId: $container.data('page-id'),
            componentTypeLabels: $container.data('component-type-labels') || {},
        },
    });

    window.componentManager = new ComponentManager(options);
});
